import styled from 'styled-components'

export const Toolbar = styled.div`
  padding-bottom: 15px;

  @media (min-width: 1200px) {
    min-width: 100%;
    max-width: 100%;
    min-height: 200px;
    position: relative; // Due to configurator view background effect
  }

  // Create configurator view background effect
  &::before {
    content: '';
    background-color: #f9f9f9;
    display: block;
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    z-index: -1;
    transform: translate(0, -100%);
  }

  & .react-tabs {
    & * .react-tabs__tab-list {
      display: flex;
      column-gap: 0;
      overflow-y: hidden;
      overflow-x: auto;
      border-bottom: none;
      scrollbar-width: thin;
      scrollbar-color: transparent transparent;
      white-space: nowrap;
      break-rows: nowrap;

      @media (hover: hover) {
        &:hover {
          scrollbar-color: ${(props) => props.theme.palette.primary.main} rgb(242, 242, 230);
        }
      }

      .react-tabs__tab {
        background-color: transparent;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        column-gap: 12px;
        padding: 15px;
        -webkit-transition: all 0.15s ease-out;
        transition: all 0.15s ease-out;
        border: none;

        &:first-of-type {
          padding-left: 39px;
        }

        @media (hover: hover) {
          &:hover {
            cursor: pointer;
            border-bottom: 3px solid ${(props) => props.theme.palette.primary.light};
          }
        }

        img {
          width: 21px;
          height: 21px;

          @media (min-width: 1200px) {
            width: 28px;
            height: 28px;
          }
        }

        &:not(.react-tabs__tab--selected) {
          border-bottom: 2px solid #e1e3e0;
        }

        &.react-tabs__tab--selected {
          border-bottom: 3px solid ${(props) => props.theme.palette.primary.main};
        }

        /* Needed to override react-tabs default styling */
        &:focus:after {
          content: none;
        }
      }
    }

    & .react-tabs__tab-panel {
      padding: 5px 10px;
    }
  }
`
